import { Wrapper } from "@Src/layout/Wrapper";
import { FormsCreate } from "@Src/resources/forms/FormsCreate";
import { FormsEdit } from "@Src/resources/forms/FormsEdit";
import { FormsList } from "@Src/resources/forms/FormsList";
import { resourceName } from "@Src/resources/forms/name";
import type { Resource } from "@Src/resources/resources_config";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";

const resource: Resource = {
	create: Wrapper(resourceName.name, "create", FormsCreate),
	edit: Wrapper(resourceName.name, "edit", FormsEdit),
	list: Wrapper(resourceName.name, "list", FormsList),
	icon: DynamicFormIcon,
	name: resourceName.name,
	path: `/${resourceName.name}`,
	apiPath: "forms/forms",
};

export default resource;
